import styled from "styled-components";

const Link = styled.a`
  font-size: 0.875rem;
  color: #fff;

  &::after {
    content: "|";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export default Link;
